import { defineAsyncComponent } from 'vue';

export { TaskAutoSuggest } from './components/TaskAutoSuggest';
export * from './components/TaskList';

export const taskMicroFrontends = {
	TimeEntrySkeleton: defineAsyncComponent(
		() => import('./components/TimeEntrySkeleton.vue')
	),
	TaskAutoSuggest: defineAsyncComponent(
		() => import('./components/TaskAutoSuggest/TaskAutoSuggest.vue')
	),
	TaskBudget: defineAsyncComponent(
		() => import('./components/TaskBudget/TaskBudget.vue')
	),
	TaskUsers: defineAsyncComponent(
		() => import('./components/TaskUsers/TaskUsers.vue')
	),
	TaskUsersGantt: defineAsyncComponent(
		() => import('./components/TaskUsersGantt/TaskUsersGantt.vue')
	),
	TaskTemplateAssignees: defineAsyncComponent(
		() =>
			import('./components/TaskTemplateAssignees/TaskTemplateAssignees.vue')
	),
	TaskHeaderProgress: defineAsyncComponent(
		() => import('./components/TaskHeader/TaskHeaderProgress.vue')
	),
	TaskPriorityMfe: defineAsyncComponent(
		() => import('./components/TaskPriority/TaskPriorityMfe.vue')
	),
};
